import Vue from "vue";
import App from "./App.vue";
import auth from "./auth/";
import store from "./data/store";
import jQuery from "jquery";
import $ from "jquery";
import "ms-signalr-client";
import router from "./router";
import "../node_modules/cropper/dist/cropper.css";
import "cropper";
import VeeValidate from "vee-validate";
import FBSignInButton from "vue-facebook-signin-button";
import fontAwesome from "font-awesome/css/font-awesome.css";
import Alert from "./components/SharedComponents/Alert";
import VueChatScroll from "vue-chat-scroll";
import datepicker from "bootstrap-datepicker";
import VueScrollTo from "vue-scrollto";
import VueAnalytics from "vue-analytics";

import VueSmoothScroll from "vue-smoothscroll";
window.$ = window.jQuery = jQuery;
import VueHead from "vue-head";

Vue.use(VueScrollTo);
var SocialSharing = require("vue-social-sharing");
Vue.use(SocialSharing);

Vue.use(VueAnalytics, {
  id: "UA-107726997-1",
  disableScriptLoader: true,
});

Vue.component("alert", Alert);
Vue.use(FBSignInButton);
Vue.use(VueHead);
Vue.use(fontAwesome);
Vue.use(VueChatScroll);
Vue.use(VeeValidate);
Vue.use(VueSmoothScroll);
Vue.mixin({
  data: function () {
    return {
      get countryCurrency() {
        return store.getters.CountryData.Currency;
      },
    };
  },
});

Vue.config.debug = process.env.NODE_ENV !== "production";

import timepicker from "timepicker";

import canvastoBlob from "blueimp-canvas-to-blob"; //using this as toBlob doesn't work with IE and Safari, it will override toBlob function.

window.moment = require("moment");
window.moment.tz = require("moment-timezone/builds/moment-timezone-with-data.min");

window.fbAsyncInit = function () {
  FB.init({
    appId: "279352372578608",
    cookie: true, // enable cookies to allow the server to access the session
    xfbml: true, // parse social plugins on this page
    version: "v2.8", // use graph api version 2.8
  });
};
(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

require("fullcalendar/dist/fullcalendar.css");
require("./assets/css/style.css");
require("./assets/css/fullcalendar-custom.css");
require("@fancyapps/fancybox/dist/jquery.fancybox.min.js");
require("@fancyapps/fancybox/dist/jquery.fancybox.min.css");
require("bootstrap-datepicker/dist/css/bootstrap-datepicker3.css");
require("bootstrap");
require("bootstrap/less/bootstrap.less");
require("font-awesome/less/font-awesome.less");
require("bootstrap-sweetalert");
require("bootstrap-sweetalert/dist/sweetalert.css");
require("timepicker/jquery.timepicker.min.css");
require("bootstrap-social/bootstrap-social.css");
require("animate.css/animate.min.css");

import fc from "fullcalendar";

export default {
  user: {
    authenticated: false,
  },
  router: router,
};

var app = new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
}).$mount(app);



// WEBPACK FOOTER //
// ./src/main.js